import api from '@/api/index.js'

const account_audit_log = {
  state: {
    loading: false,
    updating: false,
    data: null,
    // createdMoneyClaimId: null,
    // updatedMoneyClaim: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_AUDIT_LOG_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_ACCOUNT_AUDIT_LOG_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_ACCOUNT_AUDIT_LOG: (state, response) => {
      state.data = response;
      state.loading = false;
    },
    SET_ACCOUNT_AUDIT_LOG_ERROR: (state, error) => {
      state.error = error;
      state.loading = false;
    },
  },

  actions: {
    LoadAccountAuditLog({commit}, req) {
      commit('SET_ACCOUNT_AUDIT_LOG_LOADING', true)
      commit('SET_ACCOUNT_AUDIT_LOG_ERROR', null)
      return api.get(`accounts/${req.accountID}/audit-logs/${req.resourceId}`)
        .then((response) => {
          commit('SET_ACCOUNT_AUDIT_LOG', response)
          commit('SET_ACCOUNT_AUDIT_LOG_LOADING', false)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_AUDIT_LOG_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_audit_log
